module.exports = __webpack_public_path__ + "static/media/transfer-sent-for-approval.fb0a2e13.png";